import { ResourcesData, EnvironmentsData } from "../models/ResourcesTypes";

class Resources {
  static instance = new Resources();

  getEnvironments(): Promise<EnvironmentsData> {
    return fetch(`${process.env.REACT_APP_BASE_URL}/environments`)
      .then((response) => response.json())
      .catch(() => {
        return {};
      });
  }

  getPipelines() {
    return fetch(`${process.env.REACT_APP_BASE_URL}/pipelines`)
      .then((response) => response.json())
      .catch(() => []);
  }

  getResources(
    timeframe: string,
    envs: EnvironmentsData,
    env: string,
  ): Promise<ResourcesData> {
    const credentials: { [key: string]: string | null } = {};
    if (envs) {
      Object.keys(envs).forEach((key: string) => {
        credentials[key] = localStorage.getItem(key);
      });
    }
    const controller = new AbortController();
    const timeout = parseInt(process.env.REACT_APP_API_TIMEOUT || "900000", 10);
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    return fetch(
      `${process.env.REACT_APP_BASE_URL}/resources?timeframe=${timeframe}&envs=${env}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
        signal: controller.signal,
      },
    ).then((response) => {
      clearTimeout(timeoutId);
      return response.json();
    });
  }

  reprocess(
    params: {
      techno: string;
      type: string;
      months_ago?: number;
      ctrl_ids?: string;
      legacy?: boolean;
      dry?: boolean;
    },
    envs: EnvironmentsData,
  ): Promise<{ status?: string; output?: string; error?: string }> {
    const credentials: { [key: string]: string | null } = {};
    if (envs) {
      Object.keys(envs).forEach((key: string) => {
        credentials[key] = localStorage.getItem(key);
      });
    }

    const query = new URLSearchParams();
    query.set("techno", params.techno);
    query.set("type", params.type);
    if (params.months_ago !== undefined)
      query.set("months_ago", params.months_ago.toString());
    if (params.ctrl_ids) query.set("ctrl_ids", params.ctrl_ids);
    if (params.legacy) query.set("legacy", "true");
    if (params.dry) query.set("dry", "true");

    return fetch(
      `${process.env.REACT_APP_BASE_URL}/reprocess?${query.toString()}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      },
    ).then(async (response) => {
      let data: { status?: string; output?: string; error?: string };
      try {
        data = await response.json();
      } catch {
        data = { error: `HTTP ${response.status}: ${response.statusText}` };
      }
      if (!response.ok) {
        throw new Error(data.error || `Error ${response.status}`);
      }
      return data;
    });
  }

  copyDlkAndPush(
    envs: EnvironmentsData,
    params?: { dry?: boolean },
  ): Promise<{ status?: string; output?: string; error?: string }> {
    const credentials: { [key: string]: string | null } = {};
    if (envs) {
      Object.keys(envs).forEach((key: string) => {
        credentials[key] = localStorage.getItem(key);
      });
    }

    const query = new URLSearchParams();
    if (params?.dry) query.set("dry", "true");

    return fetch(
      `${process.env.REACT_APP_BASE_URL}/copy-dlk-push?${query.toString()}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(credentials),
      },
    ).then(async (response) => {
      let data: { status?: string; output?: string; error?: string };
      try {
        data = await response.json();
      } catch {
        data = { error: `HTTP ${response.status}: ${response.statusText}` };
      }
      if (!response.ok) {
        throw new Error(data.error || `Error ${response.status}`);
      }
      return data;
    });
  }
}

export default Resources.instance;
